var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgTikTok = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" }, props, { children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16m1.859 5.839v3.718c0 .825-.326 1.61-.909 2.193a3.1 3.1 0 0 1-2.193.909c-.825 0-1.61-.325-2.193-.909a3.1 3.1 0 0 1-.909-2.193c0-.825.325-1.61.909-2.193a3.1 3.1 0 0 1 2.193-.908h.575v1.63h-.575a1.466 1.466 0 0 0-1.471 1.471 1.467 1.467 0 0 0 1.471 1.471 1.467 1.467 0 0 0 1.47-1.468V7.342h1.625l.08.15c.254.469.595.913 1.018 1.24.327.254.697.433 1.105.505l.29.05-.31 1.572-.278-.05c-.331-.059-.656-.16-.96-.302a3.1 3.1 0 0 1-.938-.668", clipRule: "evenodd" }) }))); };
export default SvgTikTok;
